import React, { createContext, useState, useEffect, useContext } from "react";
import {
  login as apiLogin,
  logout as apiLogout,
  getCurrentUser,
  updateMyProfile,
} from "../utils/api.js";
import { jwtDecode } from "jwt-decode";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem("token"));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const storedToken = localStorage.getItem("token");
    if (storedToken) {
      (async () => {
        try {
          // Opcional: decodificar si quieres el id rápido
          const decoded = jwtDecode(storedToken);
          setToken(storedToken);

          // Obtener datos completos del admin desde el backend
          const { data } = await getCurrentUser();
          // data.data es el usuario devuelto por el backend
          setUser(data.data || { id: decoded.id });
        } catch (error) {
          console.error("Invalid token or error fetching current user:", error);
          setUser(null);
          setToken(null);
          localStorage.removeItem("token");
        } finally {
          setLoading(false);
        }
      })();
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (email, password) => {
    try {
      const data = await apiLogin(email, password);
      const decoded = jwtDecode(data.token);
      setToken(data.token);

      const meResponse = await getCurrentUser();
      setUser(meResponse.data.data || { id: decoded.id });

      return true;
    } catch (error) {
      console.error("Login failed:", error);
      setUser(null);
      setToken(null);
      localStorage.removeItem("token");
      throw error;
    }
  };

  const logout = () => {
    apiLogout();
    setUser(null);
    setToken(null);
  };

  const refreshUser = async () => {
    const { data } = await getCurrentUser();
    const next = data.data || null;
    setUser(next);
    return next;
  };

  const updateProfile = async (payload) => {
    const { data } = await updateMyProfile(payload);
    const next = data.data;
    setUser(next);
    return next;
  };

  const authContextValue = {
    user,
    token,
    loading,
    login,
    logout,
    refreshUser,
    updateProfile,
  };

  return (
    <AuthContext.Provider value={authContextValue}>
      {!loading && children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};
